// Events
import {
  MODAL_CLOSE_ALL,
  MODAL_TOGGLE,
  STICKY_FOOTER_TOGGLE_SECTION,
  THEME_CART_UPDATED,
} from 'events';
import { component } from 'picoapp';

import { getCart } from 'utils/cart';
import choozy from 'utils/choozy';
// Utils
import { dispatch } from 'utils/theme';

export default component((node, ctx) => {
  const { productJson } = choozy(node);
  const { optionsModal, optionsModalSection } = node.dataset;
  const productObject = JSON.parse(productJson?.innerText || '{}');

  // eslint-disable-next-line
  const submit = async (event) => {
    event.preventDefault();

    const formData = new FormData(node);

    const selectedVariantId = formData.get('id');

    if (selectedVariantId === null || selectedVariantId === 'null') {
      node.setAttribute('action', `${node.getAttribute('action')}#${node.getAttribute('id')}`);

      if (optionsModal) {
        ctx.emit(MODAL_TOGGLE, null, {
          id: optionsModal,
          props: {
            modalBox: optionsModalSection,
            modalSection: optionsModalSection,
          },
        });
      } else {
        ctx.emit(STICKY_FOOTER_TOGGLE_SECTION, null, 'sizes');
      }

      return false;
    }

    await fetch(`${node.action}.js`, {
      method: node.method,
      body: formData,
    });

    ctx.emit(MODAL_CLOSE_ALL);

    await getCart().then((response) => {
      if (response.status === 422) {
        return;
      }

      dispatch('add-to-cart', {
        product: ctx.getState().product || productObject,
        variant:
          ctx.getState().selectedVariant ||
          productObject.variants.find((variant) => `${variant.id}` === selectedVariantId),
        quantity: parseInt(formData.get('quantity') ?? 1, 10),
      });
      ctx.emit(THEME_CART_UPDATED, { cart: response });
    });
  };

  node.addEventListener('submit', submit);
  node.addEventListener('theme:trigger:submit', submit);
});
